import React from 'react';
import PropTypes from "prop-types";
import {FormattedDate, FormattedTime, FormattedMessage} from "react-intl";
import {generateUrl, routes} from "helpers/routes";
import {Link} from "react-router-dom";
import IconSvg from "components/IconSvg";
import {formatPhone} from "helpers/phone";

class ResultEntry extends React.Component {
    static propTypes = {
        contact: PropTypes.object.isRequired,
    };

    displayedMessage(contact) {
        if (contact.type === "text" && contact.text) {
            return contact.text.message;
        } else if (contact.type === "voice") {
            if (!contact.voice.timeStarted) {
                return <FormattedMessage id="catalogue.missed_call" defaultMessage="Missed call" />;
            } else if (contact.directionReceived) {
                return <FormattedMessage id="catalogue.inbound_call" defaultMessage="Incoming call" />;
            } else {
                return <FormattedMessage id="catalogue.outbound_call" defaultMessage="Outgoing call" />;
            }
        }

        return "-";
    }

    render() {
        const {contact} = this.props;
        const displayedMessage = this.displayedMessage(contact);

        const customerProfileUrl = generateUrl(routes.conversations, {
            customer: contact.customerProfile.customer.id,
            profile: contact.customerProfile.id,
            advert: contact.ad.id
        });

        return <div className="border-bottom py-2 px-2">
            <div className="text-primary">
                <strong><Link to={customerProfileUrl}>{contact.customerProfile.title}</Link></strong>
                &nbsp;
                <Link to={customerProfileUrl}>{formatPhone(contact.customerPhonenum)}</Link>
            </div>
            <div className="d-flex small text-muted contact-info">
                <div className={(contact.type === "voice" ? "voice" : "text")}>
                    {contact.type === "voice" &&
                    <IconSvg id='phone'/>
                    }
                    {displayedMessage}
                </div>
                <div className="ml-auto">
                    <FormattedDate value={contact.timeCreated * 1000}/> <FormattedTime value={contact.timeCreated * 1000}/>
                </div>
            </div>
        </div>
    }
}

export default ResultEntry;


// WEBPACK FOOTER //
// ./src/containers/Catalogue/ResultList/ResultEntry.jsx